export default __webpack_public_path__ + "static/small-image-applozic-1-cfab0b20860d73158f54523bbd44396b.png";